<p
  [class.text-danger-900]="points() < 0"
  [class.text-green]="points() >= 0">
  {{ points() < 0 ? '-' : '' }}
</p>
<img
  src="https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/points1.svg"
  alt="" />
<p data-test="points">{{ absPoints() }} pts</p>
